'use strict';

export const interScrolling = (() => {
  const headerH = Math.round(document.querySelector("header").getBoundingClientRect().height - window.innerWidth * 0.02359);
  const areaH = window.innerHeight - headerH;
  const zoneH = areaH * (window.innerWidth > window.innerHeight ? 0.25 : 0.25);
  const transWindow = areaH * (window.innerWidth > window.innerHeight ? 0.08 : 0.05);

  const numSteps = zoneH * 2.0;

  const getPercent = (entry) => {
    let value = 1;
    let direction = 0;
    const elRect = entry.intersectionRect;
    const rootRect = entry.rootBounds;
    const boundRect = entry.boundingClientRect;

    if (!elRect || !rootRect) return {value, direction};

    if (entry.intersectionRatio === 0) {
      value = 0;
      direction = (boundRect.top > rootRect.bottom) ? -1 : 1;
      // console.log('-- hidden --');
    } else if (rootRect.bottom - elRect.top < zoneH) {
      value = (rootRect.bottom - elRect.top) / zoneH;
      value = Math.max(0, value);
      direction = -1;
      // console.log('-- in bottom --',rootRect.bottom, elRect.top, zoneH,entry.intersectionRatio);
    } else if (elRect.bottom - rootRect.top < zoneH) {
      value = (elRect.bottom - rootRect.top) / zoneH;
      value = Math.max(0, value);
      direction = 1;
      // console.log('-- in top --',rootRect.top, elRect.bottom, zoneH,entry.intersectionRatio);
    }
    value = Math.max(value, entry.intersectionRatio);

    return {value, direction};
  };

  const handleIntersect = (entries, observer) => {
    entries.forEach((entry) => {
      const _inner = entry.target.querySelector('[data-scroll-inner]');
      if (!_inner) return;

      const visib = getPercent(entry);
      const transH = (entry.boundingClientRect.height / 2 < transWindow) ? entry.boundingClientRect.height / 2 : transWindow;
      const transY = visib.direction * transH - visib.direction * transH * visib.value;
      _inner.style["opacity"] = visib.value;
      setTransformStyle(_inner, `translateY(${transY}px) translateZ(0)`);
    });
  };

  const setTransformStyle = (_el, transform) => {
    if (_el) {
      _el.style["transform"] = transform;
      _el.style["webkitTransform"] = transform;
      _el.style["mozTransform"] = transform;
      _el.style["msTransform"] = transform;
    }
  };

  const buildThresholdList = () => {
    let thresholds = [];

    thresholds.push(0.0);
    for (let i = 1.0; i <= numSteps; i++) {
      let ratio = i / numSteps;
      thresholds.push(ratio);
    }
    thresholds.push(1.0);

    return thresholds;
  };

  const observer = new IntersectionObserver(handleIntersect, {
    root: null,
    rootMargin: `${-headerH}px 0px 0px`,
    threshold: buildThresholdList()
  });

  const createObserver = () => {
    const _blocks = document.querySelectorAll('[data-scroll-parent]') || [];
    _blocks.forEach(_block => {
      observer.observe(_block);
    });
  };

  const removeObserver = () => {
    const _blocks = document.querySelectorAll('[data-scroll-parent]') || [];
    _blocks.forEach(_block => {
      observer.unobserve(_block);
    });
  };

  const init = () => {
    createObserver();
  };

  const destroy = () => {
    removeObserver();
  };

  return {
    init,
    destroy
  }
})();
